import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'

export const getIsNoPlan = (
  items: IJBPPlanningItem[],
  formats: IFormActualsTargetsSettings[],
  settingsIndex: number,
  fy: number,
  fq: number,
  isContr: boolean
): boolean => {
  let result = false

  if (settingsIndex < formats.length) {
    const setting = formats[settingsIndex]

    // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
    const sourceData = items.filter(
      (el) =>
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        el.SubCategory === setting.SubCategory &&
        el.L3Category === setting.L3Category &&
        el.FYear === fy &&
        el.FQuarter === fq
    )
    if (sourceData.length >= 1) {
      const isNoPlanField = isContr ? 'IsNoPlanContractual' : 'IsNoPlan'
      result = Boolean(sourceData[0][isNoPlanField])
    } else {
      // error in data
    }
  }

  return result
}
